import { useParams } from "react-router-dom";
import { useState } from "react";
import { Container, Paper } from "@mui/material";
import StepIndicator from "../Shared/StepIndicator";
import ReservationForm from "./ReservationForm";
import DocumentPreview from "./DocumentPreview";
import PaymentSection from "./PaymentSection";
import ReviewPage from "./ReviewPage";
import Header from "../Header";

export default function CheckInPage() {
  const { roomId } = useParams();
  const [step, setStep] = useState(1);
  const [data, setData] = useState({ roomId });

  const goNext = update => {
    setData(prev => ({ ...prev, ...update }));
    setStep(s => s + 1);
  };
  const goBack = () => setStep(s => s - 1);

  return (
    <>
    <Header/>
    <Container maxWidth="lg">
      
      <Paper sx={{ px: 4, py:2, mt: 1, borderRadius: 3, boxShadow: 3 }}>
        {/* <StepIndicator current={step} /> */}
        {step === 1 && <ReservationForm roomId={roomId} onNext={goNext} />}
        {step === 2 && <DocumentPreview data={data} onNext={goNext} onBack={goBack} />}
        {step === 3 && <PaymentSection onNext={goNext} onBack={goBack} />}
        {step === 4 && <ReviewPage data={data} onNext={goNext} onBack={goBack} />}
        
      </Paper>
    </Container>
    </>
  );
}
